import React from "react";
import { DefaultButton, WarningButton, Modal } from "../../../components";

export class ConfirmationBox extends React.Component {
    state = {
      showModal: false
    };
    
    yesClick = () => {
        const { accept, cancel } = this.props;
        accept();
        cancel();
    }
    
    render() {
      const { showModal, title, message, accept, cancel } = this.props;
      
      return (
        <Modal
          show={showModal}
          title={title}
          onClose={cancel}
          body={<div>
            <div>
                <strong>{message}</strong>
            </div>
          </div>}
          footer={
            <React.Fragment>
              <DefaultButton onClick={cancel}>No</DefaultButton>
              <WarningButton onClick={this.yesClick} >Yes</WarningButton>
            </React.Fragment>
          }
        />
      )
    }    
  }
  


// WEBPACK FOOTER //
// ./src/modules/irr/components/confirmationBox.js